import { Directive, Input, OnInit, OnDestroy, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { PermissionsService } from '@services/permissions.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appHasPermission]',
  standalone: true
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);
  private permissionsService = inject(PermissionsService);
  private subscription?: Subscription;

  @Input() appHasPermission?: string; // Formato: "module:action" o solo "module"
  @Input() appHasPermissionModule?: string; // Módulo separado
  @Input() appHasPermissionAction?: string; // Acción separada
  @Input() appHasPermissionAny?: Array<{module: string, action: string}>; // Múltiples permisos (OR)
  @Input() appHasPermissionAll?: Array<{module: string, action: string}>; // Múltiples permisos (AND)

  private hasView = false;

  ngOnInit() {
    // Use the same source as route guards so menu visibility matches navigation access.
    this.subscription = this.permissionsService.loadPermissions().subscribe({
      next: () => this.updateView(),
      error: () => this.updateView()
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  private updateView() {
    let hasPermission = false;

    // Verificar permiso con formato "module:action"
    if (this.appHasPermission) {
      const [module, action] = this.appHasPermission.split(':');
      hasPermission = this.permissionsService.hasPermission(`${module}:${action || 'read'}`);
    }
    // Verificar permiso con módulo y acción separados
    else if (this.appHasPermissionModule && this.appHasPermissionAction) {
      hasPermission = this.permissionsService.hasPermission(
        `${this.appHasPermissionModule}:${this.appHasPermissionAction}`
      );
    }
    // Verificar si tiene alguno de los permisos (OR)
    else if (this.appHasPermissionAny && this.appHasPermissionAny.length > 0) {
      hasPermission = this.permissionsService.hasAnyPermission(
        this.appHasPermissionAny.map(({ module, action }) => `${module}:${action}`)
      );
    }
    // Verificar si tiene todos los permisos (AND)
    else if (this.appHasPermissionAll && this.appHasPermissionAll.length > 0) {
      hasPermission = this.appHasPermissionAll.every(({ module, action }) =>
        this.permissionsService.hasPermission(`${module}:${action}`)
      );
    }

    if (hasPermission && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!hasPermission && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}

